const truncate2Decimals = (number) => {
    let number100 = number * 100
    let numberTruncate = Math.floor(number100)
    return numberTruncate / 100
}

export default truncate2Decimals